import React, { useState } from 'react';

import { Button } from '@eika/button';
import { InfoCard } from '@eika/card';
import { RichIcon, RichIconTypes } from '@eika/rich-icon';

import { FuturePaymentListSkeleton } from '../../components/FuturePaymentsList';
import { ThemedListWrapper } from '../../components/ThemedListWrapper';
import { ErrorCardWrapper } from '../../components/shared/ErrorCardWrapper';
import type { PaymentItem } from '../../generated-types';
import useTranslation from '../../hooks/useTranslation';
import PaymentList from './PaymentList';
import StoppedPaymentDetailsModal from './StoppedPaymentDetailsModal';
import useFormattedStoppedPayments from './useFormattedStoppedPayments';

const StoppedPayments: React.FC = () => {
    const translated = useTranslation();

    const [selectedPaymentItem, setSelectedPaymentItem] = useState<PaymentItem>();

    const { isLoading, formattedStoppedPayments, refetch, error, isSuccess, enabled } = useFormattedStoppedPayments();

    const resetSelectedItem = () => {
        setSelectedPaymentItem(undefined);
    };

    if (!enabled) return <></>;

    if (error) {
        return (
            <ThemedListWrapper>
                <div className="future-payments-card__container">
                    <ErrorCardWrapper exception={error} defaultError={translated.stoppedPayments.error}>
                        <Button onClick={refetch}>{translated.tryAgain}</Button>
                    </ErrorCardWrapper>
                </div>
            </ThemedListWrapper>
        );
    }

    if (formattedStoppedPayments.length === 0 && isSuccess) {
        return (
            <ThemedListWrapper>
                <div className="future-payments-card__container">
                    <InfoCard skipBackground>
                        <RichIcon type={RichIconTypes.BAAT_M_SOL} />
                        <InfoCard.TitleH2>{translated.stoppedPayments.empty}</InfoCard.TitleH2>
                    </InfoCard>
                </div>
            </ThemedListWrapper>
        );
    }

    return (
        <ThemedListWrapper className="stopped-payments-wrapper">
            <div className="future-payments__list-container">
                {isLoading ? (
                    <FuturePaymentListSkeleton count={5} />
                ) : (
                    <PaymentList items={formattedStoppedPayments} onClick={setSelectedPaymentItem} />
                )}
            </div>
            <StoppedPaymentDetailsModal
                selectedPaymentItem={selectedPaymentItem}
                resetSelectedItem={resetSelectedItem}
            />
        </ThemedListWrapper>
    );
};

export default StoppedPayments;
